import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilterComponentDef } from '@df/catalog-ui/listing/filter/filter.component.def';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { FilterStock } from './filter-stock';

@Component({
    selector: 'filter-stock',
    templateUrl: './filter-stock.component.html',
    styleUrl: './filter-stock.component.scss',
    standalone: true,
    imports: [CommonModule, HideUpComponent, ToggleModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterStockComponent<T extends ProductDecorator> extends FilterComponentDef<T> {
    @Input({ required: true })
    override filter!: FilterStock<T>;
}
